"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _joi = require("joi");

var Joi = _interopRequireWildcard(_joi);

var _types = require("../types");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Token = Joi.object().required().keys({
    refreshToken: types.uidv4.allow(null).required().description("A token for this user that can be used to get a new accessToken using the /auth/token endpoint. This token might change over time, so for a new login, or when exchanging a refreshToken for a new accessToken a new refreshToken might be generated. Guest users don't receive a refreshToken (will be null)"),
    accessToken: types.uidv4.required().description("The main authorization token for API usage. This token has to be provided with the Authorization HTTP header as Bearer for all authenticated calls. Only valid for a limited time - see validUntil"),
    expiresIn: Joi.number().integer().required().description("Time in seconds how long the Access Token will be valid on the server. Guest users will have an accessToken that never expires (-1)"),
    tokenType: Joi.string().required().description("a string that tells you what type of token it is. You should use this type in your Authorization requests.")
}).label("Token").description("The standard response for all authentication related calls, containing token infos, user and meta infos");
exports.default = Token;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ../backend/src/shared/schemas/auth/Token.ts
 ** module id = 1265
 ** module chunks = 0
 **/